import { cn } from '@antimatterhq/ui/lib/utils';
import { formatNumber } from '../histogram.utils';

type HistogramTooltipProps = {
  value: number;
  x: number;
  y: number;
  visible: boolean;
  className?: string;
};

const HistogramTooltip = ({
  value,
  x,
  y,
  visible,
  className,
}: HistogramTooltipProps) => {
  if (!visible) return null;

  const isDarkMode = document.documentElement.classList.contains('dark');

  return (
    <div
      className={cn('pointer-events-none fixed z-50', className)}
      style={{
        left: `${x}px`,
        top: `${y}px`,
        transform: 'translate(-50%, -100%)',
      }}
    >
      {/* Tooltip content */}
      <div
        className={cn(
          'relative px-2 py-1 text-sm font-medium',
          isDarkMode ? 'bg-white text-black' : 'bg-black text-white',
        )}
      >
        {formatNumber(value)}

        {/* Pointer triangle */}
        <div
          className={cn(
            'absolute left-1/2 top-full h-0 w-0 -translate-x-1/2',
            'border-x-[6px] border-t-[6px] border-x-transparent',
            isDarkMode ? 'border-t-white' : 'border-t-black',
          )}
        />
      </div>
    </div>
  );
};

export { HistogramTooltip };
